import { useMutation } from '@tanstack/react-query';

import { useHttpClient } from '@bonusly/http-client';
import { useIdentity } from '@bonusly/who-am-i';

import { headers } from './meta';

export const companyThemePath = (prefix = '') => `${prefix}/company/theme`;

interface CompanyThemeResponse {
	id: string;
	brand: string;
	theme_color: string | null;
}

export const useUpdateCompanyTheme = () => {
	const http = useHttpClient('v2');
	const { refetchProfile } = useIdentity();

	return useMutation({
		mutationFn: async (themeColor: string | null) => {
			const response = await http.patch<CompanyThemeResponse>(companyThemePath(), { theme_color: themeColor }, { headers });
			await refetchProfile();
			return response.data;
		},
	});
};
